import { useState, useEffect } from "react";
import { ArrowLeft, Home, Plus, Edit, Trash2, Check, X } from "lucide-react";
import authService from "../../../Services/authService";

function Address() {
  const [addresses, setAddresses] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null);
  const [defaultAddressId, setDefaultAddressId] = useState(null);
  const [isAddAddressModalOpen, setIsAddAddressModalOpen] = useState(false);
  const [isEditAddressModalOpen, setIsEditAddressModalOpen] = useState(false);
  const [newAddress, setNewAddress] = useState({});
  const [selectedAddress, setSelectedAddress] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);


  const token = authService.getCurrentUsertoken();

  const [formData, setFormData] = useState({
    building_name: '',
    state_id: '',
    city_id: '',
    area: '',
    phone_number: '',
    landmark: '',
    pincode: '',
    user_id: authService.getCurrentuser().id,
  });

  useEffect(() => {
    loadAddress();
    loadStates();
  }, []);

  const loadStates = () => {
    fetch(authService.getApiUrl() + 'states', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setStates(result.data);
      })
      .catch((err) => console.log(err.message));
  };

  const loadCities = (stateId) => {
    fetch(authService.getApiUrl() + 'statebasedCity', {
      method: 'POST',
      body: JSON.stringify({ state_id: stateId }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setCities(result.data);
      })
      .catch((err) => console.log(err.message));
  };

  const loadAddress = () => {
    const url = new URL(authService.getApiUrl() + "Addresslist");

    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setAddresses(result.data);
        setDefaultAddressId(result.default_address?.id || null);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleSetDefault = (id) => {
    setAddresses(
      addresses.map((address) => ({
        ...address,
        isDefault: address.id === id,
      }))
    );

    const url = new URL(authService.getApiUrl() + "updateaddress");
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
        address_id: id,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        loadAddress();
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleDeleteClick = (id) => {
    setAddressToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = () => {
    if (addressToDelete) {
      setAddresses(addresses.filter((address) => address.id !== addressToDelete));
      setIsDeleteModalOpen(false);
      setAddressToDelete(null);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (formErrors[field]) {
      const updatedErrors = { ...formErrors };
      delete updatedErrors[field];
      setFormErrors(updatedErrors);
    }
  };



  const handleStateChange = (event) => {
    const stateId = event.target.value;
    setFormData((prev) => ({ ...prev, state_id: stateId, city_id: '' }));
    loadCities(stateId);

    // Clear state_id error if exists
    if (formErrors.state_id) {
      const updatedErrors = { ...formErrors };
      delete updatedErrors.state_id;
      setFormErrors(updatedErrors);
    }
  };

  const handleCityChange = (event) => {
    const cityId = event.target.value;
    setFormData((prev) => ({ ...prev, city_id: cityId }));

    // Clear city_id error if exists
    if (formErrors.city_id) {
      const updatedErrors = { ...formErrors };
      delete updatedErrors.city_id;
      setFormErrors(updatedErrors);
    }
  };

  const handleEditStateChange = (e) => {
    const stateId = e.target.value;
    setSelectedAddress(prev => ({ ...prev, state_id: stateId, city_id: "" }));
    //setSelectedAddress(prev => ({ ...prev, city_id: e.target.value }))
    // Also trigger fetchCities(stateId) if needed
    // alert(stateId);
    loadCities(stateId);
  };

  const handleEditCityChange = (e) => {
    setSelectedAddress(prev => ({ ...prev, city_id: e.target.value }));
  };


  const validateForm = () => {
    let newErrors = {};
    const allowedTextRegex = /^[A-Za-z0-9\s\-\/]+$/;

    // Building Name
    if (!formData.building_name) {
      newErrors.building_name = "Building Name is required";
    } else if (!allowedTextRegex.test(formData.building_name)) {
      newErrors.building_name = "Only letters, numbers, spaces, hyphen (-), and slash (/) are allowed";
    }

    // Area
    if (!formData.area) {
      newErrors.area = "Area is required";
    } else if (!allowedTextRegex.test(formData.area)) {
      newErrors.area = "Only letters, numbers, spaces, hyphen (-), and slash (/) are allowed";
    }

    // Landmark
    if (!formData.landmark) {
      newErrors.landmark = "Landmark is required";
    } else if (!allowedTextRegex.test(formData.landmark)) {
      newErrors.landmark = "Only letters, numbers, spaces, hyphen (-), and slash (/) are allowed";
    }

    // State & City
    if (!formData.state_id) newErrors.state_id = "Please select a State";
    if (!formData.city_id) newErrors.city_id = "Please select a City";

    // Pincode
    if (!formData.pincode) {
      newErrors.pincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = "Invalid Pincode";
    }

    // Phone Number
    if (!formData.phone_number) {
      newErrors.phone_number = "Phone Number is required";
    } else if (!/^\d{10}$/.test(formData.phone_number)) {
      newErrors.phone_number = "Invalid Phone Number";
    } else if (!/^[6-9]/.test(formData.phone_number)) {
      newErrors.phone_number = "Phone number must start with 6, 7, 8, or 9";
    }

    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleAddAddress = (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    fetch(authService.getApiUrl() + 'AddAddress', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        loadAddress();
        setIsAddAddressModalOpen(false);
        setFormData({
          building_name: '',
          state_id: '',
          city_id: '',
          area: '',
          phone_number: '',
          landmark: '',
          pincode: '',
          user_id: authService.getCurrentuser().id,
        });
        setFormErrors({});
      })
      .catch((err) => console.log(err.message));
  };

  const handleSaveEditAddress = (event) => {
    event.preventDefault();
    const errors = {};

    if (!selectedAddress.building_name?.trim()) errors.building_name = "Building name is required";
    if (!selectedAddress.area?.trim()) errors.area = "Area is required";
    if (!selectedAddress.landmark?.trim()) errors.landmark = "Landmark is required";
    if (!selectedAddress.state_id) errors.state_id = "State is required";
    if (!selectedAddress.city_id) errors.city_id = "City is required";
    if (!selectedAddress.phone_number?.match(/^\d{10}$/)) errors.phone_number = "Phone number must be 10 digits";
    if (!selectedAddress.pincode?.match(/^\d{6}$/)) errors.pincode = "Pincode must be 6 digits";

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    fetch(authService.getApiUrl() + 'updateAddress/' + selectedAddress.id, {
      method: 'PUT',
      body: JSON.stringify(selectedAddress),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        loadAddress();
        setIsEditAddressModalOpen(false);
        setFormData({
          building_name: '',
          state_id: '',
          city_id: '',
          area: '',
          phone_number: '',
          landmark: '',
          pincode: '',
          user_id: authService.getCurrentuser().id,
        });
        setFormErrors({});
      })
      .catch((err) => console.log(err.message));
  };

  const handleEditAddress = (address) => {
    setIsEditAddressModalOpen(true);
    setSelectedAddress(address);
    loadCities(address.state_id)
    console.log(address)
  }

  const handleEditInputChange = (field, value) => {
    setSelectedAddress((prev) => ({ ...prev, [field]: value }));

    if (formErrors[field]) {
      const updatedErrors = { ...formErrors };
      delete updatedErrors[field];
      setFormErrors(updatedErrors);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <a
          href="#" onClick={() => window.history.back()}
          className="flex items-center text-[#4A4A4A] hover:text-[#951C25] mb-6"
        >
          <ArrowLeft size={18} className="mr-2" />
          <span>Back to Home</span>
        </a>

        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-semibold text-[#4A4A4A]">My Addresses</h1>
          <button
            onClick={() => setIsAddAddressModalOpen(true)}
            className="flex items-center px-4 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
          >
            <Plus size={16} className="mr-1" />
            Add New Address
          </button>
        </div>

        {addresses.length > 0 ? (
          <div className="space-y-4">
            {addresses.map((address) => {
              const isDefault = address.id === defaultAddressId;
              return (
                <div
                  key={address.id}
                  className={`bg-white rounded-lg border ${isDefault
                    ? "border-[#951C25]"
                    : "border-[#E0E0E0]"
                    } p-4 hover:shadow-sm transition-shadow`}
                >
                  <div className="flex items-start">
                    <div className="w-10 h-10 rounded-full bg-[#F5F5F7] flex items-center justify-center mr-3 flex-shrink-0">
                      <Home size={20} className="text-[#951C25]" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-base font-medium text-[#4A4A4A]">
                        {address.building_name}
                      </h3>
                      <p className="text-sm text-[#4A4A4A]/80 mt-1">
                        {address.area}, {address.landmark}, {address.city_name},{" "}
                        {address.state_name}, {address.pincode}
                      </p>
                      <p className="text-sm text-[#4A4A4A]/70 mt-1">
                        Phone Number : {address.phone_number}
                      </p>
                      <div className="flex mt-3 space-x-3">
                        {!isDefault && (
                          <button
                            onClick={() => handleSetDefault(address.id)}
                            className="flex items-center text-xs text-[#951C25]"
                          >
                            <Check size={14} className="mr-1" />
                            Set as Default
                          </button>
                        )}
                        <button
                          // onClick={() =>
                          //   alert(`Edit address: ${address.building_name}`)
                          // } 
                          onClick={(e) => handleEditAddress(address)}
                          className="flex items-center text-xs text-[#4A4A4A]"
                        >
                          <Edit size={14} className="mr-1" />
                          Edit
                        </button>
                        {/* <button
                        onClick={() => handleDeleteClick(address.id)}
                        className="flex items-center text-xs text-red-600"
                      >
                        <Trash2 size={14} className="mr-1" />
                        Delete
                      </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        ) : (
          <div className="bg-white rounded-lg border border-[#E0E0E0] p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-[#951C25]/10 flex items-center justify-center mx-auto mb-4">
              <Home size={24} className="text-[#951C25]" />
            </div>
            <h2 className="text-lg font-medium text-[#4A4A4A] mb-2">
              No Addresses Found
            </h2>
            <p className="text-sm text-[#4A4A4A]/70 mb-4">
              You haven't added any addresses yet.
            </p>
            <button
              onClick={() => setIsAddAddressModalOpen(true)}
              className="inline-block px-4 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
            >
              Add New Address
            </button>
          </div>
        )}
      </div>

      {/* Delete Modal */}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <h3 className="text-lg font-medium text-[#4A4A4A] mb-4">
              Delete Address
            </h3>
            <p className="text-sm text-[#4A4A4A]/70 mb-6">
              Are you sure you want to delete this address? This action cannot
              be undone.
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setIsDeleteModalOpen(false)}
                className="px-4 py-2 border border-[#E0E0E0] rounded-md text-sm text-[#4A4A4A]"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-2 bg-red-600 text-white rounded-md text-sm hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {isAddAddressModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-[#E0E0E0]">
              <h2 className="text-lg font-medium text-[#4A4A4A]">Add New Address</h2>
              <button onClick={() => setIsAddAddressModalOpen(false)} className="text-[#4A4A4A] hover:text-[#951C25]">
                <X size={20} />
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Building Name, Flat Number */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Building Name, Flat Number <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2.5 border ${formErrors.building_name ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={formData.building_name || ""}
                    onChange={(e) => handleInputChange("building_name", e.target.value)}
                  />
                  {formErrors.building_name && <p className="mt-1 text-xs text-red-500">{formErrors.building_name}</p>}
                </div>

                {/* Area, Street, Sector */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Area, Street, Sector <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2.5 border ${formErrors.area ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={formData.area || ""}
                    onChange={(e) => handleInputChange("area", e.target.value)}
                  />
                  {formErrors.area && <p className="mt-1 text-xs text-red-500">{formErrors.area}</p>}
                </div>

                {/* Landmark */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Landmark <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2.5 border ${formErrors.landmark ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={formData.landmark || ""}
                    onChange={(e) => handleInputChange("landmark", e.target.value)}
                  />
                  {formErrors.landmark && <p className="mt-1 text-xs text-red-500">{formErrors.landmark}</p>}
                </div>

                {/* State */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    State <span className="text-[#951C25]">*</span>
                  </label>
                  <select
                    className={`w-full px-3 py-2.5 border ${formErrors.state_id ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25] bg-white appearance-none`}
                    name="state_id" value={formData.state_id}
                    onChange={handleStateChange}
                  >
                    <option value="">--Select--</option>
                    {states.map((item) => (
                      <option value={item.id} key={item.id}>{item.state_name}</option>
                    ))}
                  </select>
                  {formErrors.state_id && <p className="mt-1 text-xs text-red-500">{formErrors.state_id}</p>}
                </div>

                {/* City */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    City <span className="text-[#951C25]">*</span>
                  </label>
                  <select name="city_id"
                    className={`w-full px-3 py-2.5 border ${formErrors.city_id ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25] bg-white appearance-none`}
                    value={formData.city_id || ""}
                    onChange={handleCityChange}
                  >
                    <option value="">--Select--</option>
                    {cities.map((item) => (
                      <option value={item.id} key={item.id}>{item.city_name}</option>
                    ))}
                  </select>
                  {formErrors.city_id && <p className="mt-1 text-xs text-red-500">{formErrors.city_id}</p>}
                </div>

                {/* Phone Number */}
                {/* Phone Number */}
                {/* <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Phone Number <span className="text-[#951C25]">*</span>
                  </label>
                   <span className="flex items-center px-3 text-sm text-[#4A4A4A]/70 border-r border-[#E0E0E0] bg-[#F9F9F9] rounded-l-md">
      +91
    </span>
                  <input
                    type="text"
                    maxLength={10}
                    className={`w-full px-3 py-2.5 border ${formErrors.phone_number ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={formData.phone_number || ""}
                    onChange={(e) => handleInputChange("phone_number", e.target.value.replace(/\D/, ""))} // ensure digits only
                  />
                  {formErrors.phone_number && (
                    <p className="mt-1 text-xs text-red-500">{formErrors.phone_number}</p>
                  )}
                </div> */}
                {/* Phone Number */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Phone Number <span className="text-[#951C25]">*</span>
                  </label>
                  <div className={`flex rounded-md border ${formErrors.phone_number ? "border-red-500" : "border-[#E0E0E0]"} focus-within:ring-1 focus-within:ring-[#951C25] focus-within:border-[#951C25]`}>
                    <span className="flex items-center px-3 bg-[#F9F9F9] text-sm text-[#4A4A4A]/70 border-r border-[#E0E0E0] rounded-l-md">
                      +91
                    </span>
                    <input
                      type="text"
                      maxLength={10}
                      className="w-full px-3 py-2.5 rounded-r-md focus:outline-none"
                      value={formData.phone_number || ""}
                      onChange={(e) =>
                        handleInputChange("phone_number", e.target.value.replace(/\D/g, ""))
                      }
                    />
                  </div>
                  {formErrors.phone_number && (
                    <p className="mt-1 text-xs text-red-500">{formErrors.phone_number}</p>
                  )}
                </div>


                {/* Pincode */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Pincode <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2.5 border ${formErrors.pincode ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={formData.pincode || ""}
                    onChange={(e) => handleInputChange("pincode", e.target.value)}
                    maxLength={6}
                  />
                  {formErrors.pincode && <p className="mt-1 text-xs text-red-500">{formErrors.pincode}</p>}
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="p-4 border-t border-[#E0E0E0] flex justify-end">
              <button
                onClick={handleAddAddress}
                className="px-6 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      {isEditAddressModalOpen && selectedAddress && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-[#E0E0E0]">
              <h2 className="text-lg font-medium text-[#4A4A4A]">Edit Address</h2>
              <button onClick={() => setIsEditAddressModalOpen(false)} className="text-[#4A4A4A] hover:text-[#951C25]">
                <X size={20} />
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Building Name, Flat Number */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Building Name, Flat Number <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    name="building_name"
                    className={`w-full px-3 py-2.5 border ${formErrors.building_name ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={selectedAddress.building_name || ""}
                    onChange={(e) => handleEditInputChange("building_name", e.target.value)}
                  />
                  {formErrors.building_name && <p className="mt-1 text-xs text-red-500">{formErrors.building_name}</p>}
                </div>

                {/* Area, Street, Sector */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Area, Street, Sector <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2.5 border ${formErrors.area ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={selectedAddress.area || ""}
                    onChange={(e) => handleEditInputChange("area", e.target.value)}
                  />
                  {formErrors.area && <p className="mt-1 text-xs text-red-500">{formErrors.area}</p>}
                </div>

                {/* Landmark */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Landmark <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2.5 border ${formErrors.landmark ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={selectedAddress.landmark || ""}
                    onChange={(e) => handleEditInputChange("landmark", e.target.value)}
                  />
                  {formErrors.landmark && <p className="mt-1 text-xs text-red-500">{formErrors.landmark}</p>}
                </div>

                {/* State */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    State <span className="text-[#951C25]">*</span>
                  </label>
                  <select
                    className={`w-full px-3 py-2.5 border ${formErrors.state_id ? "border-red-500" : "border-[#E0E0E0]"}
    rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25] bg-white appearance-none`}
                    name="state_id"
                    value={selectedAddress.state_id?.toString() || ""}
                    onChange={handleEditStateChange}
                  >
                    <option value="">--Select--</option>
                    {states.map((item) => (
                      <option value={item.id.toString()} key={item.id}>{item.state_name}</option>
                    ))}
                  </select>
                  {formErrors.state_id && <p className="mt-1 text-xs text-red-500">{formErrors.state_id}</p>}
                </div>

                {/* City */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    City <span className="text-[#951C25]">*</span>
                  </label>
                  <select
                    name="city_id"
                    className={`w-full px-3 py-2.5 border ${formErrors.city_id ? "border-red-500" : "border-[#E0E0E0]"}
    rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25] bg-white appearance-none`}
                    value={selectedAddress.city_id?.toString() || ""}
                    onChange={handleEditCityChange}
                  >
                    <option value="">--Select--</option>
                    {cities.map((item) => (
                      <option value={item.id.toString()} key={item.id}>{item.city_name}</option>
                    ))}
                  </select>
                  {formErrors.city_id && <p className="mt-1 text-xs text-red-500">{formErrors.city_id}</p>}
                </div>

                {/* Phone Number */}
                {/* Phone Number */}
                {/* <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Phone Number <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={10}
                    className={`w-full px-3 py-2.5 border ${formErrors.phone_number ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={selectedAddress.phone_number || ""}
                    onChange={(e) => handleEditInputChange("phone_number", e.target.value.replace(/\D/g, ""))} // ensure digits only
                  />
                  {formErrors.phone_number && (
                    <p className="mt-1 text-xs text-red-500">{formErrors.phone_number}</p>
                  )}
                </div> */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Phone Number <span className="text-[#951C25]">*</span>
                  </label>
                  <div className={`flex rounded-md border ${formErrors.phone_number ? "border-red-500" : "border-[#E0E0E0]"} focus-within:ring-1 focus-within:ring-[#951C25] focus-within:border-[#951C25]`}>
                    <span className="flex items-center px-3 bg-[#F9F9F9] text-sm text-[#4A4A4A]/70 border-r border-[#E0E0E0] rounded-l-md">
                      +91
                    </span>
                    <input
                      type="text"
                      maxLength={10}
                      className="w-full px-3 py-2.5 rounded-r-md focus:outline-none"
                      value={selectedAddress.phone_number || ""}
                      onChange={(e) =>
                        handleEditInputChange("phone_number", e.target.value.replace(/\D/g, ""))
                      }
                    />
                  </div>
                  {formErrors.phone_number && (
                    <p className="mt-1 text-xs text-red-500">{formErrors.phone_number}</p>
                  )}
                </div>



                {/* Pincode */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-2">
                    Pincode <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2.5 border ${formErrors.pincode ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-md focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={selectedAddress.pincode || ""}
                    onChange={(e) => handleEditInputChange("pincode", e.target.value)}
                    maxLength={6}
                  />
                  {formErrors.pincode && <p className="mt-1 text-xs text-red-500">{formErrors.pincode}</p>}
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="p-4 border-t border-[#E0E0E0] flex justify-end">
              <button
                onClick={handleSaveEditAddress}
                className="px-6 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default Address;
